import {
  createFocusOutlineStyle,
  makeStyles,
  shorthands,
} from "@fluentui/react-components";

export const useStyles = makeStyles({
  li: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: "25%",

    ...createFocusOutlineStyle({
      selector: "focus-within",
      style: {
        outlineRadius: "32px",
        outlineOffset: {
          top: "-2px",
          bottom: "-2px",
          left: "-2px",
          right: "-2px",
        },
        outlineWidth: "2px",
      },
    }),

    "@media (min-width: 767px) and (max-width: 953px)": {
      flexShrink: 0,
      flexBasis: "33%", // once under 900px, 3 columns
    },

    "@media (min-width: 480px) and (max-width: 767px)": {
      flexShrink: 0,
      flexBasis: "50%", // once under 768, 2 columns
    },

    "@media (max-width: 480px)": {
      flexShrink: 0,
      flexBasis: "100%",
    },
  },

  root: {
    color: "#363636",
    ...shorthands.padding("2px"),
    "@media (max-width: 954px)": {
      ...shorthands.padding("0px", "8px", "2px", "8px"),
    },
    "@media (max-width: 479px)": {
      paddingRight: "16px",
    },
  },

  supCardControlImage: {
    backgroundColor: "#f3f3f3",
    width: "100%",
    height: "100%",
    position: "absolute",
    left: "0",
    top: "0",
    bottom: "0",
    backgroundSize: "cover",
    backgroundPositionX: "center",
    backgroundPositionY: "center",
    ...shorthands.borderRadius("16px"),
    ...shorthands.border("1px", "solid", "#e6e6e6"),
    cursor: "pointer",
  },

  supCardControlContentContainer: {
    width: "100%",
  },

  videoContent: {
    position: "relative",
    ...createFocusOutlineStyle({
      selector: "focus",
      style: {
        outlineRadius: "16px",
        outlineOffset: {
          top: "-2px",
          bottom: "-2px",
          left: "-2px",
          right: "-2px",
        },
        outlineWidth: "2px",
      },
    }),
  },

  supCardControlImageContainer: {
    width: "100%",
    position: "relative",
  },

  cardControlImagePlaceholderOverlay: {
    paddingBottom: "100%",
    width: "100%",
    height: "0",
  },

  cardControlPlayImageFluent: {
    backgroundColor: "rgba(255, 255, 255, .75)",
    boxShadow: "4px 8px 12px rgba(0,0,0,.25)",
    position: "absolute",
    top: "0",
    bottom: "15%",
    left: "0",
    right: "0",
    ...shorthands.margin("auto"),
    ...shorthands.borderRadius("5em"),
  },

  cardContentWrapper: {
    position: "relative",
    width: "100%",
    height: "100%",
  },

  cardContent: {
    marginTop: "0px",
    marginLeft: "0px",
    marginRight: "0px",
    marginBottom: "0px",
    paddingLeft: "12%",
    paddingRight: "12%",
    paddingTop: "3%",
    paddingBottom: "12%",
    maxHeight: "80px",
    position: "absolute",
    left: "0",
    right: "0",
    bottom: "0",
    borderBottomRightRadius: "16px",
    borderBottomLeftRadius: "16px",
    boxSizing: "border-box",
  },

  supCardControlFooter: {
    lineHeight: "unset",
    minHeight: "unset",
    marginTop: "4px",
    textOverflow: "ellipsis",
    whitespace: "nowrap",
    display: "-webkit-box",
    WebkitLineClamp: "2",
    WebkitBoxOrient: "vertical",
    ...shorthands.overflow("hidden"),
    ...shorthands.padding("0px"),
  },

  supCardControlFooterText: {
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "600",
    lineHeight: "28px",
    ...shorthands.padding("0px"),
    ...shorthands.margin("0px"),
  },
});
